import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "23",
  fill: "none",
  viewBox: "0 0 24 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.8 3a2.25 2.25 0 0 0-2.25 2.25V6h-3.3A2.25 2.25 0 0 0 2 8.25v9a2.25 2.25 0 0 0 2.25 2.25h15.5A2.25 2.25 0 0 0 22 17.25v-9A2.25 2.25 0 0 0 19.75 6h-3.3v-.75A2.25 2.25 0 0 0 14.2 3zm5.15 3v-.75a.75.75 0 0 0-.75-.75H9.8a.75.75 0 0 0-.75.75V6zM8.3 7.5H4.25a.75.75 0 0 0-.75.75v.995l8.218 3.332a.75.75 0 0 0 .564 0L20.5 9.244V8.25a.75.75 0 0 0-.75-.75H8.3m-4.8 9.75v-6.387l7.655 3.104a2.25 2.25 0 0 0 1.69 0l7.655-3.104v6.387a.75.75 0 0 1-.75.75H4.25a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }